import { bool2str, componentId, setAttributes } from '../../util';

const TOGGLE_BASE_CLASS = 'toggle-btn';

export class ToggleButton {
    constructor(button) {
        this._button = button;
        this._element = null;

        this._onOpen = this._onOpen.bind(this);
        this._onClose = this._onClose.bind(this);
        this._onClick = this._onClick.bind(this);

        this._init();
    }

    get open() {
        return this._button.getAttribute('aria-expanded') === 'true';
    }

    get button() {
        return this._button;
    }

    get element() {
        return this._element;
    }

    set open(value) {
        const previousValue = this.open;
        if (value !== previousValue) {
            this._button.setAttribute('aria-expanded', bool2str(value));
            if (value) {
                this._onOpen();
            } else {
                this._onClose();
            }
        }
    }

    _init() {
        if (this._button.hasAttribute('data-controls')) {
            this._element = document.getElementById(this._button.getAttribute('data-controls'));
        } else {
            this._element = this._button.nextElementSibling;
            if (this._element) {
                if (!this._element.hasAttribute('id')) {
                    this._element.setAttribute('id', `${TOGGLE_BASE_CLASS}__content__${componentId()}`);
                }
                this._button.setAttribute('data-controls', this._element.getAttribute('id'));
            }
        }
        if (this._button.hasAttribute('data-export')) {
            window[this._button.getAttribute('data-export')] = this;
        }
        this._button.addEventListener('click', this._onClick);
        this._toggleElement();
    }

    _swapText(field = 'data-toggle-text') {
        if (this._button.hasAttribute(field)) {
            const currentText = this._button.innerHTML;
            this._button.innerHTML = this._button.getAttribute(field);
            this._button.setAttribute(field, currentText);
        }
    }

    _toggleElement(state = null) {
        if (state === null) {
            state = this.open;
        }
        if (this._element) {
            setAttributes(this._element, {
                'aria-hidden': bool2str(!state),
                'aria-expanded': bool2str(state),
            });
        }
    }

    _onOpen() {
        this._swapText();
        this._toggleElement();
        const event = new CustomEvent('open');
        this._button.dispatchEvent(event);
    }

    _onClose() {
        this._swapText();
        this._toggleElement();
        const event = new CustomEvent('close');
        this._button.dispatchEvent(event);
    }

    _onClick() {
        this.open = !this.open;
    }
}